/*
  Skip-to-product on the quiz advertorials.
  Runs only when the variant flag is on. Control is untouched.

  Nothing page-specific lives here. The anchors, the test id and the copy come
  from the JSON the snippet writes into [data-jc-skip-config], keyed by page
  handle — see snippets/jc-lp-skip-to-product.liquid.
*/
(function () {
  // B sends the reader to the product, C scrolls them to the two questions.
  var MODES = { 'jc-skip-v1': 'skip', 'jc-skip-v2': 'questions' };
  var root = document.documentElement;
  var mode = null;
  var bar = null;
  var state = { pastFirstScreen: false, inQuiz: false };
  // Each placed button and the page's own CTA it sits under, so it can be sized to match.
  var pairs = [];
  var expected = 0;
  var flag = null;

  // Per-page config: the blocks the skip button repeats under in page order, the
  // chapter the first screen is found from (it carries no id of its own), the two
  // quiz blocks the sticky bar must never sit on top of, and the test id.
  var cfg = readConfig();
  var CHAPTERS = cfg.chapters;
  var QUIZ = cfg.quiz;

  function readConfig() {
    var fallback = { test: '', firstScreenFrom: '', firstScreen: '', chapters: [], quiz: [], ctaWrapper: '', centerFirst: false };
    var node = document.querySelector('[data-jc-skip-config]');
    if (!node) return fallback;
    try {
      var parsed = JSON.parse(node.textContent || '{}');
      return {
        test: parsed.test || '',
        firstScreenFrom: parsed.firstScreenFrom || '',
        firstScreen: parsed.firstScreen || '',
        chapters: parsed.chapters || [],
        quiz: parsed.quiz || [],
        // Hand-built pages (hj-senior) are not Replo: their CTA sits in its own
        // wrapper (".cta"), and climbing the tree the Replo way lands inside a
        // flex row. When set, the button goes straight after that wrapper.
        ctaWrapper: parsed.ctaWrapper || '',
        centerFirst: parsed.centerFirst === true
      };
    } catch (e) {
      return fallback;
    }
  }

  function variantOn() {
    var flags = Object.keys(MODES);
    for (var i = 0; i < flags.length; i += 1) {
      if (root.classList.contains(flags[i])) {
        flag = flags[i];
        mode = MODES[flag];
        return true;
      }
    }
    try {
      var param = new URLSearchParams(window.location.search).get('jc_skip');
      var found = param === '1' ? flags[0] : param === '2' ? flags[1] : null;
      if (found) {
        flag = found;
        root.classList.add(flag);
        mode = MODES[flag];
        return true;
      }
    } catch (e) {}
    return false;
  }

  function track(label) {
    try {
      if (window.dataLayer && window.dataLayer.push) {
        window.dataLayer.push({
          event: 'jc_lp_skip_click',
          jc_test: cfg.test,
          jc_variant: mode,
          jc_cta: label
        });
      }
    } catch (e) {}
  }

  // In C the same button points at the questions instead of the product.
  function applyMode(scope) {
    if (mode !== 'questions') return;
    var buttons = (scope || document).querySelectorAll('.jc-skip-btn[data-jc-questions-href]');
    [].forEach.call(buttons, function (button) {
      button.setAttribute('href', button.getAttribute('data-jc-questions-href'));
      button.textContent = button.getAttribute('data-jc-questions-label');
    });
  }

  function applyBar() {
    if (bar) bar.classList.toggle('is-visible', state.pastFirstScreen && !state.inQuiz);
  }

  function firstScreenBlock() {
    if (cfg.firstScreen) return document.querySelector(cfg.firstScreen);
    if (!cfg.firstScreenFrom) return null;
    var anchor = document.querySelector(cfg.firstScreenFrom);
    var logos = anchor && anchor.previousElementSibling; // "Bekend van"
    return logos ? logos.previousElementSibling : null;  // bullets + the page's own CTA
  }

  // The page's own CTA in a block, and the element to drop our button after.
  // Replo nests the button in `display: contents` wrappers, so we climb to the
  // first real element sitting in the block's own column — same column, same
  // alignment, which is what keeps desktop honest.
  function ctaAnchor(block) {
    if (!block) return null;
    var buttons = [].slice.call(block.querySelectorAll('button, a[href]')).filter(function (b) {
      return !b.classList.contains('jc-skip-btn');
    });
    var button = buttons[buttons.length - 1];
    if (!button) return null;
    if (cfg.ctaWrapper) {
      var wrappers = block.querySelectorAll(cfg.ctaWrapper);
      var wrapper = wrappers[wrappers.length - 1];
      if (!wrapper) return null;
      var own = wrapper.querySelector('button, a[href]');
      return own ? { wrapper: wrapper, button: own } : null;
    }
    var node = button;
    while (node.parentElement && node.parentElement !== block) {
      var parentIsColumn = window.getComputedStyle(node.parentElement).flexDirection === 'column';
      if (parentIsColumn && window.getComputedStyle(node).display !== 'contents') {
        return { wrapper: node, button: button };
      }
      node = node.parentElement;
    }
    return node.parentElement === block ? { wrapper: node, button: button } : null;
  }

  function buttonBlock() {
    var tpl = document.querySelector('[data-jc-skip-choice]');
    return tpl ? tpl.content.cloneNode(true) : null;
  }

  // Match the CTA it sits under — 358px full-bleed on mobile, 300px inside a
  // two-column chapter on desktop — and line up its left edge with it. Replo
  // centres some chapters and left-aligns others, so this is measured rather
  // than guessed, and re-measured on resize.
  function sizeButtons() {
    pairs.forEach(function (pair) {
      var ctaWrapper = cfg.ctaWrapper && pair.button.closest(cfg.ctaWrapper);
      var shouldCenter = window.innerWidth <= 768 ||
        (cfg.centerFirst && pair.el === document.querySelector('.jc-skip-choice')) ||
        (ctaWrapper && ctaWrapper.classList.contains('cta--centered'));
      if (cfg.ctaWrapper) {
        // Measure the current breakpoint's CSS width, not our previous result.
        pair.button.style.width = pair.originalWidth;
      }
      if (cfg.ctaWrapper && !shouldCenter) {
        pair.button.style.marginLeft = '';
        pair.button.style.marginRight = '';
        if (ctaWrapper) ctaWrapper.style.textAlign = '';
      }
      var button = pair.button.getBoundingClientRect();
      // Transforms affect getBoundingClientRect(). Use the untransformed layout
      // dimensions so hovering one CTA never resizes or shifts its paired CTA.
      var buttonWidth = pair.button.offsetWidth || button.width;
      var buttonHeight = pair.button.offsetHeight || button.height;
      var buttonLeft = button.left + ((button.width - buttonWidth) / 2);
      var parent = pair.el.parentElement;
      if (!buttonWidth || !parent) return;
      var parentBox = parent.getBoundingClientRect();
      var parentStyle = window.getComputedStyle(parent);
      var contentLeft = parentBox.left +
        (parseFloat(parentStyle.paddingLeft) || 0) +
        (parseFloat(parentStyle.borderLeftWidth) || 0);
      var rowGap = parseFloat(parentStyle.rowGap) || 0;
      var availableWidth = 0;
      pair.el.style.alignSelf = 'stretch';
      pair.el.style.marginLeft = Math.max(0, Math.round(buttonLeft - contentLeft)) + 'px';
      pair.el.style.marginRight = 'auto';

      if (cfg.ctaWrapper) {
        // The hand-built senior pages use short green CTAs alongside a longer
        // skip label. Let the blue button grow with its copy, but never beyond
        // the available content width. Keeping a real 12px gap also avoids the
        // negative margin produced by subtracting a grid row-gap here.
        availableWidth = Math.max(0, parentBox.right - contentLeft -
          (parseFloat(parentStyle.paddingRight) || 0) -
          (parseFloat(parentStyle.borderRightWidth) || 0) -
          Math.max(0, buttonLeft - contentLeft));
        pair.el.style.width = 'max-content';
        pair.el.style.minWidth = Math.min(Math.round(buttonWidth), Math.round(availableWidth)) + 'px';
        pair.el.style.maxWidth = Math.round(availableWidth) + 'px';
        pair.el.style.marginTop = '12px';
      } else {
        // Replo chapter columns already provide their own row gap. Pull the
        // inserted button back up so it remains visually paired with the CTA.
        pair.el.style.width = '';
        pair.el.style.minWidth = '';
        pair.el.style.maxWidth = Math.round(buttonWidth) + 'px';
        pair.el.style.marginTop = Math.round(12 - rowGap) + 'px';
      }

      // Same pill as the page's own button: Replo puts the label in an inner
      // element, so the type is read from there rather than from the button.
      var label = pair.button.querySelector('*') || pair.button;
      var buttonStyle = window.getComputedStyle(label);
      var el = pair.el.querySelector('.jc-skip-btn');
      if (el) {
        el.style.fontSize = buttonStyle.fontSize;
        el.style.fontWeight = buttonStyle.fontWeight;
        if (cfg.ctaWrapper) el.style.fontFamily = buttonStyle.fontFamily;
        el.style.height = Math.round(buttonHeight) + 'px';
        el.style.paddingTop = '0';
        el.style.paddingBottom = '0';

        if (cfg.ctaWrapper && availableWidth) {
          // Treat the original CTA and the inserted skip CTA as one group:
          // whichever label needs more room determines both button widths.
          var groupWidth = Math.min(
            Math.round(availableWidth),
            Math.max(
              Math.round(buttonWidth),
              Math.ceil(pair.button.scrollWidth),
              Math.ceil(el.scrollWidth) // Measure the button itself, not its wrapper.
            )
          );
          pair.button.style.width = groupWidth + 'px';
          pair.el.style.width = groupWidth + 'px';
          pair.el.style.minWidth = groupWidth + 'px';

          if (shouldCenter) {
            if (ctaWrapper) ctaWrapper.style.textAlign = 'center';
            pair.button.style.marginLeft = 'auto';
            pair.button.style.marginRight = 'auto';
            pair.el.style.marginLeft = 'auto';
            pair.el.style.marginRight = 'auto';
          } else {
            pair.button.style.marginLeft = '';
            pair.button.style.marginRight = '';
            pair.el.style.marginLeft = Math.max(0, Math.round(buttonLeft - contentLeft)) + 'px';
            pair.el.style.marginRight = 'auto';
          }
        }
      }
    });
  }

  function placeUnder(block) {
    if (!block) return false;
    var target = ctaAnchor(block);
    if (!target) return false;
    target.button.setAttribute('data-jc-skip-source', '');
    var next = target.wrapper.nextElementSibling;
    if (next && next.classList.contains('jc-skip-choice')) return true;
    var frag = buttonBlock();
    if (!frag) return false;
    var el = frag.firstElementChild;
    target.wrapper.parentNode.insertBefore(frag, next);
    applyMode(el);
    pairs.push({ el: el, button: target.button, originalWidth: target.button.style.width });
    return true;
  }

  function placeChoice() {
    var blocks = [firstScreenBlock()].concat(CHAPTERS.map(function (sel) {
      return document.querySelector(sel);
    }));
    // Replo can re-render a section and take our button with it, so forget the
    // ones that are no longer in the document before counting.
    pairs = pairs.filter(function (pair) { return document.contains(pair.el); });
    expected = blocks.filter(Boolean).length;
    var placed = blocks.filter(function (b) { return placeUnder(b); }).length;
    sizeButtons();
    refreshBar();
    return placed === blocks.length;
  }

  // The flag class and the buttons are both things Replo or an app can wipe on a
  // late re-render. This puts them back rather than leaving a half-rendered arm.
  function heal() {
    if (flag && !root.classList.contains(flag)) root.classList.add(flag);
    if (!expected || document.querySelectorAll('.jc-skip-choice').length < expected) placeChoice();
  }

  // Replo hijacks the page scroll and hydrates sections late, so nothing here reads
  // window.scrollY: the bar is driven by where the elements actually are on screen.
  function refreshBar() {
    if (!bar) return;
    var choice = [].slice.call(document.querySelectorAll('.jc-skip-choice')).filter(function (el) {
      return el.getClientRects().length && window.getComputedStyle(el).display !== 'none';
    })[0];
    var vh = window.innerHeight;
    // Into the story: the first skip button has scrolled off the top.
    state.pastFirstScreen = !!choice && choice.getBoundingClientRect().bottom < 0;
    // Never sit on top of a quiz answer.
    state.inQuiz = QUIZ.some(function (sel) {
      var el = document.querySelector(sel);
      if (!el) return false;
      var r = el.getBoundingClientRect();
      return r.top < vh && r.bottom > 0;
    });
    applyBar();
  }

  function watchScroll() {
    var queued = false;
    var onScroll = function () {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(function () {
        queued = false;
        refreshBar();
      });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () {
      sizeButtons();
      onScroll();
    }, { passive: true });
    // Replo reflows as sections hydrate; a slow tick keeps the bar and the widths honest.
    setInterval(function () {
      heal();
      sizeButtons();
      refreshBar();
    }, 500);
    refreshBar();
  }

  function wireClicks() {
    document.addEventListener('click', function (e) {
      var cta = e.target.closest && e.target.closest('[data-jc-skip-cta]');
      if (!cta) return;
      track(cta.getAttribute('data-jc-skip-cta'));
      var href = cta.getAttribute('href') || '';
      if (href.charAt(0) !== '#') return;
      var dest = document.querySelector(href);
      if (!dest) return;
      e.preventDefault();
      dest.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  function start() {
    if (!CHAPTERS.length) return; // no config for this page
    if (!variantOn()) return;
    bar = document.querySelector('[data-jc-skip-bar]');
    if (bar) {
      bar.hidden = false;
      applyMode(bar);
    }
    wireClicks();

    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      // Replo hydrates late, so keep trying for ~10s before giving up.
      if (placeChoice() || tries > 40) clearInterval(timer); // watchScroll keeps healing after this
    }, 250);
    if (placeChoice()) clearInterval(timer);
    watchScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
